(function () {
  function parseValue(raw) {
    var text = String(raw || '').trim();
    var rangeMatch = text.match(/^([^0-9]*)(\d+(?:\.\d+)?)(\s*[–—-]\s*)(\d+(?:\.\d+)?)(.*)$/);
    if (rangeMatch) {
      return {
        type: 'range',
        prefix: rangeMatch[1],
        from: parseFloat(rangeMatch[2]),
        separator: rangeMatch[3],
        to: parseFloat(rangeMatch[4]),
        suffix: rangeMatch[5],
        decimalsFrom: (rangeMatch[2].split('.')[1] || '').length,
        decimalsTo: (rangeMatch[4].split('.')[1] || '').length
      };
    }

    var singleMatch = text.match(/^([^0-9]*)(\d+(?:\.\d+)?)(.*)$/);
    if (singleMatch) {
      return {
        type: 'single',
        prefix: singleMatch[1],
        value: parseFloat(singleMatch[2]),
        suffix: singleMatch[3],
        decimals: (singleMatch[2].split('.')[1] || '').length
      };
    }

    return { type: 'static', text: text };
  }

  function formatNumber(n, decimals) {
    if (decimals > 0) return n.toFixed(decimals);
    return String(Math.round(n));
  }

  function animateValue(el, duration) {
    var parsed = parseValue(el.getAttribute('data-value') || el.textContent);
    if (parsed.type === 'static') {
      el.textContent = parsed.text;
      return;
    }

    var start = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) duration = 0;

    function frame(now) {
      if (start === null) start = now;
      var t = duration <= 0 ? 1 : Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);

      if (parsed.type === 'range') {
        var a = parsed.from * eased;
        var b = parsed.to * eased;
        el.textContent =
          parsed.prefix +
          formatNumber(a, parsed.decimalsFrom) +
          parsed.separator +
          formatNumber(b, parsed.decimalsTo) +
          parsed.suffix;
      } else {
        el.textContent =
          parsed.prefix +
          formatNumber(parsed.value * eased, parsed.decimals) +
          parsed.suffix;
      }

      if (t < 1) requestAnimationFrame(frame);
    }

    if (parsed.type === 'range') {
      el.textContent =
        parsed.prefix +
        formatNumber(0, parsed.decimalsFrom) +
        parsed.separator +
        formatNumber(0, parsed.decimalsTo) +
        parsed.suffix;
    } else {
      el.textContent = parsed.prefix + formatNumber(0, parsed.decimals) + parsed.suffix;
    }

    requestAnimationFrame(frame);
  }

  function initStats(root) {
    if (!root || root.dataset.wxStatsReady === '1') return;
    root.dataset.wxStatsReady = '1';

    var values = Array.prototype.slice.call(root.querySelectorAll('[data-wx-count]'));
    if (!values.length) return;

    var played = false;
    function play() {
      if (played) return;
      played = true;
      values.forEach(function (el, i) {
        setTimeout(function () {
          animateValue(el, 1400);
        }, i * 120);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play();
              io.disconnect();
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(root);
    } else {
      play();
    }
  }

  function boot() {
    document.querySelectorAll('[data-wx-stats]').forEach(initStats);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-wx-stats]');
    if (root) {
      delete root.dataset.wxStatsReady;
      initStats(root);
    }
  });
})();
